// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__qCnJc","productName":"Table_productName__24p9e"};